<template>
    <Layout>
        <div class="tea-grid-content">
            <div class="tea-grid-content-children">
                <el-row :gutter="24">
                    <transition appear appear-to-class="animate__animated animate__backInDown ">
                        <el-col :span="24">
                            <div class="nav">
                                <div class="nav-item active">
                                    <div class="name">
                                        <div class="txt">
                                            数据分析
                                        </div>
                                        <div class="sub-txt">
                                            Data analysis
                                        </div>
                                    </div>
                                </div>
                                <div class="nav-item" :class="{active:stepsIndex>2}">
                                    <div class="name">
                                        <div class="txt">
                                            上架和结果
                                        </div>
                                        <div class="sub-txt">
                                            National basic information
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </transition>
                    <transition appear appear-to-class="animate__animated animate__fadeInDown animate__delay-1s">
                        <el-col :span="24">
                            <div class="M-step">
                                <div class="step-item active" style="width: 200px" @click="$router.push('/home')">
                                    <div class="title">
                                        <div class="text">
                                            首 页
                                        </div>
                                        <div class="subText">
                                            HOME
                                        </div>
                                    </div>
                                </div>
                                <div class="step-item" :class="{active:stepsIndex>=index}" v-for="(item,index) in steps"
                                     :key="index" @click="$router.push({path:item.fullpath,query:$route.query})">
                                    <div class="icon">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div class="title">
                                        <div class="text">
                                            {{item.name.txt}}
                                        </div>
                                        <div class="subText">
                                            {{item.name.subTxt}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </transition>
                    <el-col :span="24">
                        <router-view></router-view>
                    </el-col>
                </el-row>
            </div>
        </div>
    </Layout>
</template>

<script>

  export default {
    data() {
      return {
        steps: [
          {
            name: {
              txt: '数据获取来源',
              subTxt: 'Data sources'
            },
            path: 'source',
            active: true,
            fullpath:'/data/source'
          },
          {
            name: {
              txt: '数据生成',
              subTxt: 'Data generation'
            },
            path: 'generation',
            active: false,
            fullpath:'/data/generation'
          },
          {
            name: {
              txt: '数据对比分析',
              subTxt: 'Comparative analysis of data'
            },
            path: 'comparison',
            active: false,
            fullpath:'/data/comparison'
          },
          {
            name: {
              txt: '选定商品上架',
              subTxt: 'Selected products on sale'
            },
            path: 'putaway',
            active: false,
            fullpath:'/data/putaway'
          },
          {
            name: {
              txt: '生产实验结果',
              subTxt: 'Production experiment results'
            },
            path: 'result',
            active: false,
            fullpath:'/data/result'
          },
        ],
        stepsIndex: 0
      }
    },
    created() {

    },
    methods: {
      getStepIndex(path) {
        this.steps.forEach((item, index) => {
          if (path.indexOf(item.path) > -1) {
            this.stepsIndex = index
          }
        })
      }
    },
    mounted() {
      this.getStepIndex(this.$route.fullPath)
    },
    beforeRouteUpdate(to, from, next) {
      this.getStepIndex(to.fullPath)
      next()
    },
    beforeRouteEnter(to,from,next){
      next(vm=>{
        vm.$axios.get('/student/statistics/enter')
      })
    },
    beforeRouteLeave(to, from, next) {
      this.$axios.get('/student/statistics/leave')
      next()
    }
  }
</script>

<style scoped lang="scss">
    @mixin title {
        padding: 30px 30px 0 30px;
        margin-bottom: 10px;
        .text {
            font-size: 26px;
            font-weight: bold;
            line-height: 33px;
        }
        .subText {
            font-size: 12px;
            font-weight: 400;
            line-height: 15px;
            color: #999999;
        }
    }

    .backHome {
        position: fixed;
        right: 40px;
        bottom: 100px;
        cursor: pointer;
        box-shadow: 0 0 10px #FE4A49;
        border-radius: 50%;
        z-index: 10;
    }

    .tea-grid-content {
        width: 100%;

        .tea-grid-content-children {
            max-width: 1600px;
            margin: 0 auto;
        }
    }

    .nav {
        padding: 0 20%;
        height: 84px;
        margin-bottom: 12px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
            display: inline-block;
            height: 100%;
        }

        .nav-item {
            text-align: center;
            height: 100%;
            display: flex;
            align-items: center;
            font-size: 30px;
            font-family: Microsoft YaHei UI, serif;
            font-weight: bold;
            color: #333333;
            padding: 0 16px;
            margin-right: 160px;
            position: relative;

            .name {
                .txt {

                }

                .sub-txt {
                    margin-top: 8px;
                    text-align: center;
                    font-size: 10px;
                    font-weight: 400;
                    text-transform: uppercase;
                }
            }

            &.active {
                color: #005BE7;

                .name .sub-txt {
                    color: #005BE7;
                }
            }

            &.active:before {
                content: '';
                position: absolute;
                bottom: 0;
                left: -15px;
                width: calc(100% + 30px);
                height: 8px;
                background: #005BE7;
                border-radius: 8px;

            }

            &:last-child {
                margin-right: 0;
            }

        }
    }

    .M-step {
        display: flex;
        margin-bottom: 24px;

        .step-item {
            width: 300px;
            height: 80px;
            margin-right: 26px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            background: white;
            color: #999999;
            &:hover {
                cursor: pointer;
            }

            &.active {
                background: linear-gradient(270deg, #005BE7 0%, #70A0EB 100%);

                & .title {
                    color: white;
                }
            }

            .icon {
                div:nth-child(1) {
                    position: absolute;
                    left: 10px;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    width: 22px;
                    height: 22px;
                    background: white;
                    border-radius: 50%;
                    box-shadow: 0px 0px 0px 5px #00000014 inset;
                }

                div:nth-child(2) {
                    position: absolute;
                    left: -55px;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    background: white;
                    box-shadow: 0px 1px 3px rgba(0, 100, 235, 0.3);
                    width: 82px;
                    height: 12px;
                    z-index: 2;
                    border-radius: 12px;
                }

                div:nth-child(3) {
                    position: absolute;
                    left: -60px;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    width: 22px;
                    height: 22px;
                    background: white;
                    border-radius: 50%;
                    box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.05) inset;
                }
            }

            &:last-child {
                margin-right: 0;
            }

            .title {
                text-align: center;

                .text {
                    height: 33px;
                    font-size: 26px;
                    font-weight: 400;
                    line-height: 33px;
                }

                .subText {

                }
            }
        }
    }


</style>
